import { useState } from 'react';

const useRandom = () => {
  const [value, setValue] = useState(Math.random());
  const refresh = () => setValue(Math.random());
  return [value, refresh];
};

export default useRandom;
